<template>
  <div role="list">
    <v-divider :class="{ 'no-top-margin': isOnTop }"></v-divider>
    <v-hover>
      <v-list-tile
        class="toc-list-tile elevation-2 secondary"
        slot-scope="{ hover }"
        style="padding-top: 5px; padding-left: 0px; height: 60px;"
        color="blue"
        v-if="
          !item.hasOwnProperty('hideInLayers') || item.hideInLayers == false
        "
        @click="toggleProfileOpen(item)"
      >
        <v-btn
          icon
          style="margin-left: -6px;"
          ripple
          label="Utvid kartlag"
          aria-label="Utvid kartlag"
          :disabled="item.type == 'sceneLayer' || item.type == 'featureLayer'"
          @click.stop="toggleProfileOpen(item)"
        >
          <v-icon size="22" color="dark-grey">{{
            item.type === "imageryLayer"
              ? "mdi-satellite-variant"
              : item.open
              ? "mdi-folder-open-outline"
              : "mdi-folder-outline"
          }}</v-icon>
        </v-btn>

        <v-list-tile-content>
          <v-list-tile-sub-title style="max-width: 200px; min-width: 10px">{{
            item.appTitle ? item.appTitle : "Uten navn"
          }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-spacer></v-spacer>

        <v-fade-transition>
          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action
                v-on="on"
                style="min-width: 30px;"
                class="pa-0 ma-0"
                v-show="hover && item.type !== 'imageryLayer'"
              >
                <v-btn
                  class="pa-0 ma-0"
                  icon
                  small
                  aria-label="Vis informasjon om kartlaget"
                  flat
                  :disabled="!profileHasDescription"
                  @click.stop="openInfo($event, item)"
                >
                  <v-icon size="20">mdi-information-variant</v-icon>
                </v-btn>
              </v-list-tile-action>
            </template>
            <span>Vis info</span>
          </v-tooltip>
        </v-fade-transition>

        <v-fade-transition>
          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action
                v-on="on"
                style="min-width: 30px;"
                class="pa-0 ma-0"
                v-show="
                  hover && item.type !== 'imageryLayer' && item.canBeDownloaded
                "
              >
                <v-btn
                  class="pa-0 ma-0"
                  icon
                  aria-label="Last ned datasett"
                  :href="getProfileDownloadUrl(item.id)"
                  small
                  flat
                >
                  <v-icon size="20">mdi-arrow-down</v-icon>
                </v-btn>
              </v-list-tile-action>
            </template>
            <span>Last ned data (åpner i ny fane)</span>
          </v-tooltip>
        </v-fade-transition>

        <v-fade-transition>
          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action
                v-on="on"
                style="min-width: 30px;"
                class="pa-0 ma-0"
                v-show="hover && item.type === 'graphicsLayer'"
              >
                <v-btn
                  class="pa-0 ma-0"
                  icon
                  small
                  flat
                  aria-label="Rediger tegnelaget"
                  :disabled="tools.drawing.active"
                  @click.stop="editDrawingLayer"
                >
                  <v-icon size="20">mdi-pencil-outline</v-icon>
                </v-btn>
              </v-list-tile-action>
            </template>
            <span>Rediger</span>
          </v-tooltip>
        </v-fade-transition>

        <v-fade-transition>
          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action
                v-on="on"
                style="min-width: 30px;"
                class="pa-0 ma-0"
                v-show="hover && item.type === 'graphicsLayer'"
              >
                <v-btn
                  class="pa-0 ma-0"
                  icon
                  small
                  aria-label="Kjør geometrisk operasjon"
                  flat
                  @click.stop="activateGeometryCalculatorDialog"
                >
                  <v-icon size="20">mdi-function</v-icon>
                </v-btn>
              </v-list-tile-action>
            </template>
            <span>Kjør geometrisk operasjon</span>
          </v-tooltip>
        </v-fade-transition>

        <v-fade-transition>
          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action
                v-on="on"
                style="min-width: 30px;"
                class="pa-0 ma-0"
                v-if="item.type === 'imageryLayer'"
              >
                <v-list-tile-action-text
                  ><v-menu
                    ref="menu"
                    v-model="datePickerMenu"
                    :close-on-content-click="true"
                    lazy
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-layout row class="secondary" style="padding: 5px;">
                        <v-btn
                          v-show="hover"
                          class="pa-0 ma-0"
                          small
                          flat
                          aria-label="Gå til forrige dag"
                          icon
                          @click="subtractDate"
                        >
                          <v-icon size="20">mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-btn class="pa-0 ma-0" small flat v-on="on">
                          {{ profileDate | moment("DD.MM.YYYY") }}
                        </v-btn>
                        <v-btn
                          v-show="hover"
                          class="pa-0 ma-0"
                          small
                          aria-label="Gå til neste dag"
                          flat
                          icon
                          @click="addDate"
                        >
                          <v-icon size="20">mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-layout>
                    </template>
                    <v-date-picker
                      locale="nb"
                      :max="item.maxDate"
                      :show-current="true"
                      v-model="profileDate"
                      color="grey"
                      reactive
                    ></v-date-picker> </v-menu
                ></v-list-tile-action-text>
              </v-list-tile-action>
            </template>
            <span>Velg dato</span>
          </v-tooltip>
        </v-fade-transition>

        <v-fade-transition>
          <v-tooltip bottom open-delay="800" close-delay="0">
            <template v-slot:activator="{ on }">
              <v-list-tile-action
                v-on="on"
                @click.stop
                style="min-width: 30px"
                v-show="hover || menu"
              >
                <layer-list-item-menu
                  @menu-open="menu = true"
                  @menu-close="menu = false"
                  @place-on-top="placeOnTop"
                  @place-on-bottom="placeOnBottom"
                  :item="item"
                />
              </v-list-tile-action>
            </template>
            <span>Flere valg</span>
          </v-tooltip>
        </v-fade-transition>

        <v-tooltip bottom open-delay="800" close-delay="0">
          <template v-slot:activator="{ on }">
            <v-list-tile-action v-on="on" style="min-width: 30px;">
              <v-btn
                style="margin-top: 2px"
                @wheel.stop="visibilityScrolled"
                icon
                label="Slå kartlag av/på"
                aria-label="Slå kartlag av/på"
                :style="{ opacity: opacity }"
                small
                flat
                @click.stop="toggleTheme"
              >
                <v-icon
                  :color="item.visible ? 'blue' : 'grey'"
                  style="font-size: 20px;"
                  >{{ item.visible ? "mdi-eye" : "mdi-eye-off" }}</v-icon
                >
              </v-btn>
              <v-fade-transition>
                <v-icon
                  v-show="hover && item.visible"
                  :disabled="opacity == 1.0"
                  @click.stop="increaseOpacity"
                  style="position: absolute; margin-top: -18px; right: 11px;"
                  color="blue"
                  size="25"
                  >mdi-menu-up</v-icon
                >
              </v-fade-transition>

              <v-fade-transition>
                <v-icon
                  v-show="hover && item.visible"
                  :disabled="opacity == 0.2"
                  @click.stop="decreaseOpacity"
                  style="position: absolute; margin-top: 24px; right: 11px;"
                  color="blue"
                  size="25"
                  >mdi-menu-down</v-icon
                >
              </v-fade-transition>
            </v-list-tile-action>
          </template>
          <span>Skru kartlag av eller på. Justér synlighet vha. scroll.</span>
        </v-tooltip>
      </v-list-tile>
    </v-hover>

    <div v-if="item.open && item.type !== 'imageryLayer'">
      <layer-list-item-toc
        style="margin-top: 2px; margin-bottom: 1px;"
        :layer="item.id"
        :sublayer-index="null"
        :show-subheaders="false"
        :padding="0"
      ></layer-list-item-toc>
    </div>

    <div v-if="item.open && item.type === 'graphicsLayer'">
      <layer-list-item-toc-graphicslayer
        :layer="item.id"
        :padding="0"
      ></layer-list-item-toc-graphicslayer>
    </div>
    <geometry-calculator-dialog
      v-if="item.type === 'graphicsLayer'"
      :selected-graphics-layer="item"
      :active="geometryCalculatorDialogActive"
      @close-dialog="deactivateGeometryCalculatorDialog"
    ></geometry-calculator-dialog>
  </div>
</template>

<script>
import LayerListItemToc from "@/pages/MapPage/Tools/Layers/LayerListItemToc";
import MappingMixin from "@/mixins/mappingMixin";
import LayerListItemTocGraphicslayer from "@/pages/MapPage/Tools/Layers/LayerListItemTocGraphicslayer";
import LayerListItemMenu from "@/pages/MapPage/Tools/Layers/LayerListItemMenu";
import { mapState, mapActions } from "vuex";
import GeometryCalculatorDialog from "@/pages/MapPage/Tools/Drawing/GeometryCalculatorDialog";

export default {
  name: "LayerListItem",
  components: {
    LayerListItemToc,
    LayerListItemMenu,
    LayerListItemTocGraphicslayer,
    GeometryCalculatorDialog
  },
  mixins: [MappingMixin],
  computed: {
    ...mapState(["selectedTheme", "tools", "theMap"]),
    profileDate: {
      set(profileDate) {
        this.updateMapProfileDate({
          id: this.item.id,
          newDate: profileDate
        });
      },
      get() {
        return this.item.date;
      }
    },
    profileHasDescription() {
      return this.item.Temaforklaring;
    }
  },
  methods: {
    ...mapActions([
      "toggleProfileOpen",
      "setSelectedMapProfile",
      "activateTool",
      "setSelectedTheme",
      "setShowInfoMenu"
    ]),
    getProfileDownloadUrl(id) {
      return process.env.VUE_APP_DOWNLOAD_MAP_DATA_SERVICE_URL + id + "&";
    },
    subtractDate: function() {
      let dateParts = this.profileDate.split("-");
      let date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
      date.setDate(date.getDate() - 1);
      this.profileDate =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    },
    addDate: function() {
      let dateParts = this.profileDate.split("-");
      let date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
      date.setDate(date.getDate() + 1);

      this.profileDate =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    },
    openInfo(evt, item) {
      this.setSelectedTheme(item.id);
      this.setShowInfoMenu(true);
    },
    editDrawingLayer() {
      this.setSelectedMapProfile(this.item);
      this.activateTool("drawing");
    },
    visibilityScrolled(event) {
      event.preventDefault();
      if (event.deltaY < 0) {
        this.increaseOpacity();
      } else if (event.deltaY > 0) {
        this.decreaseOpacity();
      }
    },
    closeTheme() {
      if (this.item.open) {
        this.toggleProfileOpen(this.item);
      }
    },
    openTheme() {
      if (!this.item.open) {
        this.toggleProfileOpen(this.item);
      }
    },
    toggleTheme() {
      if (this.item.visible) {
        this.closeTheme();
      } else {
        this.openTheme();
      }
      this.setMapLayerVisibility({
        profile: this.item,
        visible: !this.item.visible
      });
    },
    decreaseOpacity() {
      this.opacity = this.theMap.findLayerById(this.item.id).opacity;
      if (this.opacity > 0.2) {
        this.opacity = Number(this.opacity - 0.2).toFixed(2);
      }
      this.setMapLayerOpacity({
        id: this.item.id,
        opacity: this.opacity
      });
    },
    increaseOpacity() {
      this.opacity = this.theMap.findLayerById(this.item.id).opacity;
      if (this.opacity < 1) {
        this.opacity = Number(this.opacity + 0.2).toFixed(2);
      }
      this.setMapLayerOpacity({
        id: this.item.id,
        opacity: this.opacity
      });
    },
    reorder(id, newIndex) {
      let exisitingLayer = this.$theMapObject.findLayerById(id);
      newIndex = newIndex + 2;
      this.$theMapObject.reorder(exisitingLayer, newIndex);
    },
    placeOnTop() {
      let mapProfilesCopy = JSON.parse(JSON.stringify(this.mapProfiles));
      let index = this.mapProfiles.findIndex(
        profile => profile.id === this.item.id
      );
      let profileBeingMoved = mapProfilesCopy.splice(index, 1)[0];
      mapProfilesCopy.push(profileBeingMoved);
      this.mapProfiles = mapProfilesCopy;
      this.reorder(this.item.id, this.mapProfiles.length + 1);
    },
    placeOnBottom() {
      let mapProfilesCopy = JSON.parse(JSON.stringify(this.mapProfiles));
      let index = this.mapProfiles.findIndex(
        profile => profile.id === this.item.id
      );
      let profileBeingMoved = mapProfilesCopy.splice(index, 1)[0];

      mapProfilesCopy.unshift(profileBeingMoved);

      this.mapProfiles = mapProfilesCopy;
      this.reorder(this.item.id, 0);
    },
    deactivateGeometryCalculatorDialog() {
      this.geometryCalculatorDialogActive = false;
    },
    activateGeometryCalculatorDialog() {
      this.geometryCalculatorDialogActive = true;
    }
  },
  props: {
    item: Object,
    isOnTop: Boolean,
    isOnBottom: Boolean
  },
  data() {
    return {
      menu: false,
      datePickerMenu: false,
      layerExpanded: false,
      opacity: 1.0,
      geometryCalculatorDialogActive: false
    };
  },
  mounted: function() {
    let layer = this.theMap.findLayerById(this.item.id);
    if (typeof layer !== "undefined") {
      this.opacity = layer.opacity;
    }
  }
};
</script>

<style lang="scss">
.no-top-margin {
  opacity: 0;
  margin-top: 3px;
}

.toc-list-tile {
  .v-list__tile__sub-title {
    max-height: 42px;
    white-space: initial;
  }
}
</style>
